module.exports = __webpack_public_path__ + "static/media/copied.15eb0956.svg";